import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Index() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(1200px 600px at 20% 15%, rgba(16,185,129,0.20), transparent 60%), radial-gradient(900px 500px at 85% 70%, rgba(59,130,246,0.18), transparent 55%), #0B1220',
        padding: 24
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 520, width: '100%' }}>
        <h1
          style={{
            margin: 0,
            color: '#E5E7EB',
            fontSize: 32,
            letterSpacing: 0.2
          }}
        >
          DocLine
        </h1>
        <p style={{ marginTop: 12, marginBottom: 22, color: '#94A3B8', lineHeight: 1.5 }}>
          Acesse o sistema para entrar e gerenciar seus documentos.
        </p>

        <button
          type="button"
          onClick={() => navigate('/login')}
          style={{
            cursor: 'pointer',
            width: '100%',
            maxWidth: 340,
            border: 0,
            borderRadius: 14,
            padding: '14px 18px',
            fontSize: 16,
            fontWeight: 700,
            color: '#0B1220',
            background: 'linear-gradient(135deg, #10B981, #34D399)',
            boxShadow: '0 10px 30px rgba(16,185,129,0.25)'
          }}
        >
          Docline
        </button>
      </div>
    </div>
  );
}

